import React from 'react';
import PropTypes from 'prop-types';

import FileUploader from 'Components/Files/Uploader';
import { decode } from 'querystring';

function Uploader({ url, ...rest }) {
  const params = decode(url.split('?')[1]);

  return <FileUploader params={params} url={url} {...rest} />;
}
Uploader.propTypes = {
  url: PropTypes.string.isRequired,
};

export default Uploader;
